<template>
  <Catalogs
    title="Источники лидов"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'LeadSourceAdd'"
    :route-edit="'LeadSourceEdit'"
    :route-view="'LeadSourceView'"
    :route-path="'/lead_sources'"
    :can-edit="canEditLeadSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LeadSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'lead-sources-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'lead-sources-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getLeadSources(data);
    },
    canEditLeadSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_LEAD_SOURCE_EDIT]);
    }
  }
}
</script>

<style>
.lead-sources-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.lead-sources-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadSources/LeadSources.vue